// Геометрия усиков «Траекторий по HSI» для карты. Расчёта здесь нет: бэкенд
// вернул полный усик (origin→now→горизонт прогноза), а мы раскладываем его на
// линию и кружок-origin.
//
// До 11.09.2026 ползунок дней РЕЗАЛ усик долей «от origin до якоря», а сам усик
// всегда рос от сегодня: на −7 оставались одни кружки, на сегодня — вся неделя.
// Длина на экране зависела от даты, а обязана быть всегда 7 суток (замечание
// пользователей). Теперь конец усика — выбранный день: его дату бэкенд получает
// в запросе, и резать здесь нечего.
//
// Прогнозное плечо за «сейчас» (узел meta.now_index) в статичную линию не
// попадает — оно живёт только в кометах.

import type { HsiDriftCollection } from '../api'

/** Опознание усика для подсветки при наведении: округлённый origin трассы.
 *
 *  Не индекс в массиве: выборка перезапрашивается на каждом сдвиге карты, и
 *  подсветка живёт фильтром по этому значению — оно обязано держаться за САМ
 *  усик, а не за его место в выборке (тот же довод, что у ключа фазы комет,
 *  hsiCometFrame.ts). */
function trackId(origin: [number, number]): string {
  return `${origin[0].toFixed(3)},${origin[1].toFixed(3)}`
}

export interface HsiDriftLineProps {
  hsi: number
  /** Идентификатор усика — по нему его подсвечивает ореол при наведении. */
  tid: string
}

export interface HsiDriftSlices {
  /** Усики-линии origin→«сейчас» (только длиной ≥ 2). */
  lines: GeoJSON.FeatureCollection<GeoJSON.LineString, HsiDriftLineProps>
  /** Кружки-origin — массив ненулевых HSI-точек 7 дн назад (всегда все). */
  origins: GeoJSON.FeatureCollection<GeoJSON.Point, { hsi: number }>
}

/** Готовая коллекция усиков → линии и кружки для карты.
 *
 * Кружок-origin показываем у каждого усика (первая координата трека = origin).
 * Линию — от origin до узла «сейчас», целиком: хвост за ним — прогнозное плечо,
 * историей оно не является. Легаси-ответ (now_index=null/нет поля) — усик
 * кончается «сейчас» на последней координате. */
export function hsiDriftShapes(fc: HsiDriftCollection): HsiDriftSlices {
  const lines: GeoJSON.Feature<GeoJSON.LineString, HsiDriftLineProps>[] = []
  const origins: GeoJSON.Feature<GeoJSON.Point, { hsi: number }>[] = []

  for (const feat of fc.features) {
    const coords = feat.geometry.coordinates as [number, number][]
    if (coords.length === 0) continue
    const hsi = feat.properties.hsi

    origins.push({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: coords[0] },
      properties: { hsi },
    })

    const last = Math.min(fc.meta.now_index ?? coords.length - 1, coords.length - 1)
    if (last >= 1) {
      lines.push({
        type: 'Feature',
        geometry: { type: 'LineString', coordinates: coords.slice(0, last + 1) },
        properties: { hsi, tid: trackId(coords[0]) },
      })
    }
  }

  return {
    lines: { type: 'FeatureCollection', features: lines },
    origins: { type: 'FeatureCollection', features: origins },
  }
}
